// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","imageLink":"imageLink_imageLink__TgGLR"};